import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ServerAgent } from "../../services/AgentAPI";

/** An agent as held in FE state — same shape as the Rust `Agent` model. */
export type Agent = ServerAgent;

interface AgentsState {
  agents: Agent[];
}

const initialState: AgentsState = { agents: [] };

export const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    setAgents: (state, action: PayloadAction<Agent[]>) => {
      state.agents = action.payload;
    },
  },
});

export const { setAgents } = agentsSlice.actions;

export const selectAgents = (state: RootState) => state.agents.agents;

export default agentsSlice.reducer;
